define((require) => {
    "use strict";

    const ImprovedModel = require("shared/zbone/ImprovedModel");

    return ImprovedModel.extend({

        defaults: {

            /**
             * The trigger type e.g. <tt>hover</tt>
             * @type {String}
             */
            triggerType: null,

            /**
             * The effect type e.g. <tt>opacity</tt>
             * @type {String}
             */
            type: null,

            duration: 500,

            postDelay: 0
        }

    }, {
        TRIGGER_TYPE_HOVER: "hover",
        TRIGGER_TYPE_ATTENTION: "attention"
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/action/effects/EffectModel.js